import React from 'react';
import classes from './BoxNotification.module.scss';
import classNames from 'classnames';
import { capitalizeString } from '../../../helpers/capitalizeString';
import { AllowedChildrenType, validateChildren } from '../../../helpers/validateChildren';

export type BoxNotificationViewProps = {
  //
  type: 'info' | 'error' | 'success' | 'warning';
  children: React.ReactNode | JSX.Element;
  customClassNames?: string;
  disabled?: boolean;
};

export const AllowedChildrenForBoxNotification: AllowedChildrenType[] = [
  'string',
  'span',
  'p',
  'em',
  'strong',
  'a',
  'br',
  'Link',
  'pre'
];

export const BoxNotificationView = (props: BoxNotificationViewProps): JSX.Element => {
  const typeClassName = capitalizeString(props.type);
  const globalClasses = classNames(
    classes.BoxNotification,
    props.customClassNames,
    classes[`BoxNotification${typeClassName}`],
    {
      [classes.BoxNotificationDisabled]: props.disabled
    }
  );

  if (process.env.NODE_ENV !== 'production') {
    validateChildren(props.children, AllowedChildrenForBoxNotification);
  }
  return <div className={globalClasses}>{props.children}</div>;
};
